import { render, staticRenderFns } from "./dataRuleSetting.vue?vue&type=template&id=49534b0a&scoped=true"
import script from "./dataRuleSetting.vue?vue&type=script&lang=js"
export * from "./dataRuleSetting.vue?vue&type=script&lang=js"
import style0 from "./dataRuleSetting.vue?vue&type=style&index=0&id=49534b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49534b0a",
  null
  
)

export default component.exports